import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { getFontSize } from "../../AppFont";
import { FullScreenLoader } from "../../components/full-screen-loader/full-screen-loader";
import { useInitiatives } from "./home2.hooks";
import { WelcomeHelpCard } from "./components/welcome-help-card/welcome-help-card";
import { InitiativeListCard } from "./components/initiative-list-card/initiative-list-card";
import { ReferenceLibraryCard } from "./components/reference-library-card/reference-library-card";

export const HomeScreen2 = () => {
  const [searchParams] = useSearchParams();
  const refChapterId = searchParams.get("ref_cid");
  
  const {
    loading,
    error,
    initiatives,
    referenceDocuments,
    learnerDetails,
    learnerFirstName,
    refdocCountByDocumentId,
    refetch,
  } = useInitiatives();

  if (loading) return <FullScreenLoader />;
  if (error) return <Navigate to="/login" replace />;

  const initiativesWithQuestions = initiatives.filter((i) => i.questionCount > 0);

  // Convert refdocCountByDocumentId to string-keyed object format expected by RefdocItem
  const refdocCount: { [k: string]: number } = {};
  Object.entries(refdocCountByDocumentId).forEach(([id, count]) => {
    refdocCount[id] = count;
  });

  return (
    <div
      style={{
        background: "rgb(234, 234, 241)",
        fontSize: getFontSize(),
      }}
      className="overflow-auto flex-1 min-w-0 px-4 pb-8"
    >
      <div className="pt-8">
        <WelcomeHelpCard firstName={learnerFirstName} refdocCount={refdocCount} />
      </div>
      <div className="mt-4">
        <InitiativeListCard initiatives={initiativesWithQuestions} refetchInitiatives={refetch} />
      </div>
      <div className="mt-5">
        <ReferenceLibraryCard 
          chapters={referenceDocuments} 
          refdocCount={refdocCount} 
          initialExpandedChapterId={refChapterId ? parseInt(refChapterId, 10) : undefined}
        />
      </div>
    </div>
  );
};
